import { usePropsResolutionWithComponentTheme } from './usePropsResolution';
export function usePropsWithComponentTheme(localTheme, propsReceived, _state) {
  return usePropsResolutionWithComponentTheme(localTheme, propsReceived, _state);
}
//# sourceMappingURL=usePropsWithComponentTheme.js.map